export const NAV = {
    ADMIN: "admin",
    ASSORTMENTS: "assortments",

    BRAND_MANAGEMENT: "management",
    BRAND_PROFILE: "brand-profile",

    CAMPAIGNS: "campaigns",
    CONNECTION_REQUESTS: "connection-requests",
    CONTACTS: "contacts",
    CONTACT_GROUPS: "contact-groups",
    CREATE_LINESHEET: "create-linesheet",
    CUSTOM_LISTS: "lists",

    DASHBOARD: "dashboard",

    ENTER_IMPERSONATION: "enter-impersonation",

    FIND_NEW_ACCOUNTS: "marketplace",

    PRIVACY: "privacy",
    TERMS: "terms",
    HELP_DESK: "helpdesk",
    HOME: "home",

    PIN: "pin",

    LINESHEETS: "linesheets",
    LOG_OUT: "log-out",

    MARKETPLACES: "marketplaces",
    MANAGE_CREDIT_CARDS: "credit-cards",
    MEDIA: "media",

    ONLINE_TRADESHOW: "browse",
    DIGITAL_TRADE_SHOWS: "digital-trade-shows",
    DIGITAL_FASHION_WEEKS: "digital-fashion-weeks",
    ORDERS: "orders",
    ORDERS_CANCELLED_STYLES: "orders-cancelled-styles",
    PAYMENTS_MANAGEMENT: "payments-management",
    CHARGEBACKS_MANAGEMENT: "chargebacks",
    DAILY_TRANSACTIONS: "daily-transactions",
    INVOICES_MENU_ITEM: "invoices-menu-item",

    PAGES_MANAGER: "pages",
    PRODUCTS: "gallery",
    PROFILE_MENU: "profile-menu",
    EDIT_PROFILE: "profile",
    CUSTOM_LIST: "lists",
    RETAILER_SETTINGS: "retailer-settings",
    REPORTING: "reporting",
    REQUEST_IMPERSONATION: "request-impersonation",

    SETTINGS: "settings",
    SITE_NAV: "site-nav",
    SMART_GROUPS: "smart-group",
    STATIC_GROUPS: "static-group",
    STOP_IMPERSONATION: "stop-impersonation",

    UTILITIES: "utilities",

    VIEW_CAMPAIGNS: "view-campaigns",

    WHITEBOARDS: "whiteboards",

    SITES_MANAGER: "sites-manager",
    THE_WALL: "nav-the-wall-settings",

    B2B_LIGHTSPEED_RETAIL: "b2b-lightspeed-retail",
    B2B_MERCHANT_MANAGEMENT: "b2b-merchant-management",

    BREADCRUMBS: "breadcrumbs",
};
